module.exports = __webpack_public_path__ + "img/OBUNoOrder_02.7019142a.png";